import { breakpoints, UIBreakpoint } from "@shared/constaints/ui";

interface ReturnCurrentBreakpoint {
  currentBreakpoint: UIBreakpoint;
  currentWidth: number;
}

export const getCurrentBreakpoint = (): ReturnCurrentBreakpoint => {
  const currentWidth = window.innerWidth;

  const sorted: [UIBreakpoint, number][] = Object.entries(breakpoints) as [UIBreakpoint, number][];
  sorted.sort(([, a], [, b]) => a - b);

  let currentBreakpoint: UIBreakpoint = 'base';

  for (const [key, minWidth] of sorted) {
    if (currentWidth >= minWidth) {
      currentBreakpoint = key;
    } else {
      break;
    }
  }

  return { currentBreakpoint, currentWidth };
};

export const sortedBreakpoints = Object.entries(breakpoints)
  .sort(([, a], [, b]) => a - b)
  .map(([key]) => key as UIBreakpoint);
